import React from 'react';
const IconBase = ({
  children,
  className,
  ...props
}: any) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className={className} {...props} data-id="element-158">
    {children}
  </svg>;
// Ecosystem Icons
export const IconMoney = (props: any) => <IconBase {...props} data-id="element-159">
    <rect x="2" y="6" width="20" height="12" rx="2" data-id="element-160" />
    <circle cx="12" cy="12" r="2" data-id="element-161" />
    <path d="M6 12h.01M18 12h.01" data-id="element-162" />
  </IconBase>;
export const IconCredit = (props: any) => <IconBase {...props} data-id="element-163">
    <rect x="2" y="5" width="20" height="14" rx="2" data-id="element-164" />
    <path d="M2 10h20" data-id="element-165" />
    <path d="M6 15h4" data-id="element-166" />
  </IconBase>;
export const IconAI = (props: any) => <IconBase {...props} data-id="element-167">
    <path d="M12 3a9 9 0 0 0 0 18 9 9 0 0 0 0-18Z" data-id="element-168" />
    <path d="M12 8v8" data-id="element-169" />
    <path d="M8 12h8" data-id="element-170" />
    <circle cx="12" cy="12" r="2" data-id="element-171" />
    <path d="M10 10l-2-2M14 10l2-2M10 14l-2 2M14 14l2 2" data-id="element-172" />
  </IconBase>;
export const IconSoftware = (props: any) => <IconBase {...props} data-id="element-173">
    <rect x="4" y="4" width="16" height="16" rx="2" data-id="element-174" />
    <path d="M4 9h16" data-id="element-175" />
    <path d="M9 4v16" data-id="element-176" />
  </IconBase>;
export const IconRewards = (props: any) => <IconBase {...props} data-id="element-177">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-178" />
  </IconBase>;
export const IconBusiness = (props: any) => <IconBase {...props} data-id="element-179">
    <rect x="2" y="7" width="20" height="14" rx="2" data-id="element-180" />
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" data-id="element-181" />
    <path d="M12 12v2" data-id="element-182" />
  </IconBase>;
// Trust Section Icons
export const IconEditorial = (props: any) => <IconBase {...props} data-id="element-183">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" data-id="element-184" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" data-id="element-185" />
    <path d="M10 6h6M10 10h6M10 14h2" data-id="element-186" />
  </IconBase>;
export const IconResearch = (props: any) => <IconBase {...props} data-id="element-187">
    <circle cx="11" cy="11" r="8" data-id="element-188" />
    <path d="M21 21l-4.35-4.35" data-id="element-189" />
    <path d="M11 8v6" data-id="element-190" />
    <path d="M8 11h6" data-id="element-191" />
  </IconBase>;
export const IconHumanAI = (props: any) => <IconBase {...props} data-id="element-192">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" data-id="element-193" />
    <circle cx="9" cy="7" r="4" data-id="element-194" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" data-id="element-195" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" data-id="element-196" />
  </IconBase>;
export const IconUpdates = (props: any) => <IconBase {...props} data-id="element-197">
    <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" data-id="element-198" />
    <path d="M21 3v5h-5" data-id="element-199" />
    <path d="M12 7v5l3 3" data-id="element-200" />
  </IconBase>;